import React from 'react';

import { SvgProps } from '../enums';

export const FlagME: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55049"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55049)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V12H0V0Z"
        fill="#E8AA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H14V10H2V2Z"
        fill="#C51918"
      />
      <mask
        id="mask1_270_55049"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="12"
        height="8"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2H14V10H2V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55049)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M10.1154 7.87568C10.3193 7.87568 10.4846 7.70627 10.4846 7.4973C10.4846 7.28833 10.3193 7.11892 10.1154 7.11892C9.91147 7.11892 9.74615 7.28833 9.74615 7.4973C9.74615 7.70627 9.91147 7.87568 10.1154 7.87568Z"
          fill="#1E5E91"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M5.31378 6.16592C4.34516 5.0402 5.73341 3.08661 5.73341 3.08661C5.73341 3.08661 5.94095 4.25338 6.70913 5.03851C6.70913 5.09426 6.63659 5.17652 6.56315 5.2598C6.51186 5.31796 6.46013 5.37662 6.43236 5.42709C6.36482 5.54985 6.59669 5.61982 6.70913 5.61982C6.7596 5.61982 6.78749 5.69301 6.81265 5.75907C6.84356 5.84019 6.87037 5.91056 6.92987 5.82142C7.03782 5.65969 6.82192 5.30433 6.82192 5.30433L7.1637 4.94383L7.27929 4.7108H7.1637V4.47087L7.08271 4.53738C7.08271 4.53738 6.99385 4.32286 6.82192 4.32286C6.64999 4.32286 6.59669 4.22476 6.59669 4.22476H6.82192C6.9347 4.22476 6.80389 4.07531 6.70913 3.99747C6.66666 3.96257 6.60222 3.9746 6.54405 3.98547C6.47244 3.99883 6.41032 4.01043 6.41032 3.93057C6.41032 3.84303 6.47848 3.83144 6.55723 3.81804C6.6087 3.80928 6.66469 3.79975 6.70913 3.76775C6.78264 3.71482 6.88172 3.73109 6.98897 3.74871C7.04578 3.75804 7.10488 3.76775 7.1637 3.76775H7.44218C7.54274 3.76775 7.27929 3.93057 7.27929 3.93057L7.44218 4.07531L7.68442 4.32286L7.56328 4.39476L7.81325 4.63716C7.81325 4.63716 7.72839 4.77512 7.81325 4.77512C7.84822 4.77512 7.87123 4.80378 7.88621 4.83748C7.90118 4.80378 7.92419 4.77512 7.95917 4.77512C8.04402 4.77512 7.95917 4.63716 7.95917 4.63716L8.20914 4.39476L8.08799 4.32286L8.33023 4.07531L8.49313 3.93057C8.49313 3.93057 8.22967 3.76775 8.33023 3.76775H8.60871C8.66753 3.76775 8.72663 3.75804 8.78344 3.74871C8.8907 3.73109 8.98977 3.71482 9.06328 3.76775C9.10772 3.79975 9.16372 3.80928 9.21518 3.81804C9.29393 3.83144 9.36209 3.84303 9.36209 3.93057C9.36209 4.01043 9.29997 3.99883 9.22837 3.98547C9.17019 3.9746 9.10576 3.96257 9.06328 3.99747C8.96852 4.07531 8.83771 4.22476 8.9505 4.22476H9.17572C9.17572 4.22476 9.12243 4.32286 8.9505 4.32286C8.77856 4.32286 8.6897 4.53738 8.6897 4.53738L8.60871 4.47087V4.7108H8.49313L8.60871 4.94383L8.9505 5.30433C8.9505 5.30433 8.73459 5.65969 8.84254 5.82142C8.90204 5.91056 8.92885 5.84019 8.95976 5.75907C8.98493 5.69301 9.01281 5.61982 9.06328 5.61982C9.17572 5.61982 9.40759 5.54985 9.34005 5.42709C9.31228 5.37662 9.26055 5.31796 9.20926 5.2598C9.13582 5.17652 9.06328 5.09426 9.06328 5.03851C9.83146 4.25338 10.039 3.08661 10.039 3.08661C10.039 3.08661 11.4273 5.0402 10.4586 6.16592C9.49001 7.29165 8.77856 6.95219 8.77856 6.95219C8.77856 6.95219 9.63665 7.75052 9.73166 7.7507C9.74505 7.75073 9.71513 7.67705 9.68547 7.604C9.65619 7.5319 9.62716 7.46042 9.64025 7.46098C9.66787 7.46217 9.72216 7.5277 9.77664 7.59346C9.82006 7.64588 9.8636 7.69845 9.89386 7.71869C9.91334 7.73172 9.98944 7.70529 10.06 7.68079C10.1196 7.66009 10.1752 7.64077 10.1892 7.64785C10.2487 7.67785 10.2335 7.73856 10.219 7.79637C10.2153 7.81123 10.2116 7.82591 10.2093 7.83981C10.2071 7.85246 10.2833 7.80307 10.3634 7.75111C10.4475 7.69656 10.5359 7.63919 10.5426 7.64785C10.5441 7.64967 10.5456 7.65152 10.5472 7.65344C10.5758 7.68784 10.6218 7.74326 10.2818 8.00531C10.2818 8.05569 10.2836 8.09679 10.2851 8.13019C10.2898 8.23743 10.291 8.2652 10.2183 8.2652C10.186 8.2652 10.1407 8.28124 10.0883 8.29983C9.95377 8.3475 9.77215 8.41187 9.64025 8.2652C9.45691 8.06133 8.33023 7.24079 8.33023 7.24079L8.20914 7.30833C8.20914 7.30833 8.62181 8.44718 8.84254 8.4551C8.95223 8.45904 8.78567 8.56549 8.56503 8.7065C8.34166 8.84925 8.06287 9.02742 7.95917 9.17051C7.9283 9.2131 7.90445 9.14817 7.88621 9.00696C7.86796 9.14817 7.84411 9.2131 7.81325 9.17051C7.70954 9.02742 7.43075 8.84925 7.20738 8.7065C6.98674 8.56549 6.82018 8.45904 6.92987 8.4551C7.1506 8.44718 7.56328 7.30833 7.56328 7.30833L7.44218 7.24079L6.99385 7.75574C6.99385 7.75574 6.3155 8.06133 6.13216 8.2652C6.00027 8.41187 5.81864 8.3475 5.68416 8.29983C5.63172 8.28124 5.58645 8.2652 5.55409 8.2652C5.43874 8.2652 5.40013 8.10381 5.55409 7.90593C5.64442 7.78982 5.7827 7.77429 5.91452 7.75949C6.00735 7.74906 6.09699 7.739 6.16442 7.69441C6.32762 7.58653 6.59669 7.30833 6.59669 7.30833L6.99385 6.95219C6.99385 6.95219 6.2824 7.29165 5.31378 6.16592Z"
          fill="#F6C540"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M6.21653 8.51517L5.77897 7.74806C5.77897 7.74806 5.20689 6.42902 5.20689 6.26887C5.20689 6.10872 4.97658 5.63448 4.97658 5.77214C4.97658 5.9098 4.95752 7.01369 4.95752 7.01369L5.94182 8.44337V8.6147H6.0718L6.21653 8.51517Z"
          fill="#F6C540"
        />
        <path
          d="M9.72095 7.48246L9.78752 7.26151L10.6005 7.50642L10.5339 7.72738L9.72095 7.48246Z"
          fill="#F6C540"
        />
        <path
          d="M10.1539 7.08017L10.3737 7.15213L10.159 7.84114L9.93915 7.76918L10.1539 7.08017Z"
          fill="#F6C540"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.06858 2.64626C8.03669 2.6337 8.0028 2.62201 7.96693 2.61121L7.96427 2.62049C7.93268 2.61459 7.90314 2.61121 7.87692 2.61121C7.86754 2.61121 7.85773 2.61165 7.84756 2.61247L7.8472 2.61121C7.8452 2.61182 7.8432 2.61242 7.84121 2.61303C7.7842 2.61847 7.71637 2.63566 7.6474 2.65803C7.2829 2.69929 7.09454 2.85961 7.11539 3.13549C7.1261 3.27719 7.17359 3.37822 7.25307 3.43545V3.51988C7.25307 3.51988 7.66897 3.79024 7.87692 3.79024C8.08487 3.79024 8.50077 3.51988 8.50077 3.51988V3.46732C8.61538 3.42152 8.68362 3.30899 8.69673 3.13549C8.7182 2.85148 8.51794 2.68994 8.13202 2.65469L8.13096 2.66617C8.11007 2.65907 8.08919 2.65237 8.06858 2.64626ZM8.50077 3.30076V2.93345C8.54599 2.98401 8.56449 3.0479 8.55863 3.12538C8.55252 3.20623 8.53415 3.26409 8.50077 3.30076ZM7.25307 3.11904V3.07806C7.25223 3.09126 7.25223 3.10492 7.25307 3.11904Z"
          fill="#F6C540"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M6.97688 5.17973C6.97688 5.17973 7.54572 5.07238 7.8538 5.07238C8.13034 5.07238 8.73072 5.17973 8.73072 5.17973C8.73072 5.85975 8.92209 6.27608 8.73072 6.74054C8.53936 7.205 8.07171 6.98174 7.86004 7.4262C7.58954 7.00462 7.22421 7.23667 6.97688 6.63636C6.72954 6.03605 7.12725 5.75956 6.97688 5.17973Z"
          fill="#1E5E91"
        />
        <mask
          id="mask2_270_55049"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="6"
          y="5"
          width="3"
          height="3"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M6.97688 5.17973C6.97688 5.17973 7.54572 5.07238 7.8538 5.07238C8.13034 5.07238 8.73072 5.17973 8.73072 5.17973C8.73072 5.85975 8.92209 6.27608 8.73072 6.74054C8.53936 7.205 8.07171 6.98174 7.86004 7.4262C7.58954 7.00462 7.22421 7.23667 6.97688 6.63636C6.72954 6.03605 7.12725 5.75956 6.97688 5.17973Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_270_55049)">
          <rect
            x="6.97687"
            y="6.59865"
            width="1.75385"
            height="0.851351"
            fill="#5EAA22"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M7.89996 6.4C8.17611 6.4 8.39996 6.17614 8.39996 5.9C8.39996 5.62386 8.17611 5.4 7.89996 5.4C7.62382 5.4 7.39996 5.62386 7.39996 5.9C7.39996 6.17614 7.62382 6.4 7.89996 6.4Z"
          fill="#F6C540"
        />
      </g>
    </g>
  </svg>
);
